import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import TableImage from "../../../../Componets/Image";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import Table from "../../../../Componets/Table";
import { get_all_sales_returns } from "../../../../Controllers/Sales/Returns";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Billings/Returns/tables";
import headers from "../../../../Data/Tables/Billings/Returns/headers";
import ValueTag from "../../../../Componets/Valuetag";
import Loadercomponent from "../../../../Componets/Loader";
import moment from "moment";
import { useLocation } from "react-router-dom";
import DateTimeBadge from "../../../../Componets/DateTime/DateTimeBadge";

const BillingsReturnsTable = () => {
  let location = useLocation();

  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      supplier: headerdata?.supplier,
      contractor: headerdata?.contractor,
      date: headerdata?.date,
      due_date: headerdata?.due_date,
      status: headerdata?.status,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      unit: headerdata?.unit,
      category: headerdata?.category,
      brand: headerdata?.brand,
      type: headerdata?.type,
      status: headerdata?.status,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        customer: tabledata?.customer,
        status: tabledata?.status,
        date: tabledata?.date,
        due_date: tabledata?.due_date,
        page: tabledata?.currentPage,
      };

      const sales_returns = await get_all_sales_returns(data);
      if (sales_returns?.status) {
        let data = [];

        sales_returns?.data?.data?.map((value, index) => {
          data?.push({
            path:
              location?.pathname == "/app/billing/returns"
                ? `/app/billing/returns/view/${value?._id}`
                : `/app/sales/returns/view/${value?._id}`,
            Number: `#SR-${value?.number}`,
            Customer: value?.customer?.nam
              ? value?.customer?.nam
              : "Walk-in-customer",
            Date: <DateTimeBadge date={value?.date} />,
            Due: <DateTimeBadge date={value?.due_date} />,
            "Billed By": value?.created_by?.name,
            Total: value?.total?.toFixed(3),
            Delivery:
              value?.delivery_status === 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Delivered
                </span>
              ) : value?.delivery_status === 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Pending
                </span>
              ),
            Payment:
              value?.payment_status === 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Paid
                </span>
              ) : value?.payment_status === 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Unpaid
                </span>
              ),
            Status: <Status status={value?.status} />,
            Action:
              location?.pathname === "/app/billing/returns" ? null : (
                <ActionButton
                  edit={`/app/sales/returns/edit/${value?._id}`}
                  id={value?._id}
                  api="delete-sales-return"
                  actiondata={actiondata}
                  headers={header}
                />
              ),
          });
        });

        setPagination({
          currentPage: sales_returns?.data?.currentPage,
          totalCount: sales_returns?.data?.totalCount,
          totalPages: sales_returns?.data?.totalPages,
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(sales_returns?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default BillingsReturnsTable;
